module.exports = __webpack_public_path__ + "img/CHorseman64_ua.2050d5fe.webp";